import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "Shop",
    "Product",
    "Category",
    "bankAccount",
    "removedBankAccount",
    "Gateway",
    "User",
    "UserDocument",
    "Admin",
    "Ticket",
    "TicketList",
    "Agent",
    "Address",
    "Document",
    "Transaction",
    "Wallet",
    "Withdraw",
    "GatewayAdmin",
    "News",
    "Event",
    "Service",
    "Partner",
    "ShopAddressList",
    "ShopShippingList",
    "ShopCommentList",
    "ShopOrderList",
    "ShopUser",
    "ShopDocument",
    "ShopTicketList",
    "ShopTicket",
    "Shaparak",
  ],

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL,
    prepareHeaders: (headers, api) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");

      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", "Bearer " + token);
      return headers;
    },
  }),

  endpoints: () => ({}),
});
